import { Injectable } from '@angular/core';

import { DataService } from '../../data.service';
import { Observable } from 'rxjs';

@Injectable()
export class SchedulerViewService {

    constructor(private dataService: DataService) { }

    getSupportersMeetings(): Observable<any> {
        return this.dataService.get('Meeting/GetSupportersUpcomingMeetings', {});
    }

    getCategories(): Observable<any> {
        return this.dataService.get('Category/GetAdminCategories', {});
    }

    getSupportersByTeam(): Observable<any> {
        return this.dataService.get('Supporter/GetSupportersByTeam', {});
    }

    getSupporterDetails(email: string): Observable<any> {
        return this.dataService.get('Supporter/GetSupporterDetailsIfExists', {email: email});
    }

    getAvailabilitySlotsDetails(): Observable<any> {
        return this.dataService.get('Availability/GetAvailabilitiesSlots', {});
    }

    getSupporters(): Observable<any> {
        return this.dataService.get('Supporter/GetSupportersDto', {});
    }
}
